import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 12B388EE-036B-45AF-8390-122E6BA125CF
 * name alpha-u-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaUCircleOutlineIcon = createSvgIcon(<><path d="M9,7H11V15H13V7H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" /></>, 'AlphaUCircleOutlineIcon');
export default AlphaUCircleOutlineIcon